import type { CampoLeido, LecturaCaso, ValorCampo } from '../../api/feriasApi';
import { CAMPOS, valorVacio } from './campos';

/** De qué parte la pantalla de verificación (diseño M3 §4 de fct-ferias). */
export interface PuntoDePartida {
  /** El valor inicial de cada campo. */
  valores: Record<string, ValorCampo>;
  /** La lectura de la que salen los valores, que viaja con la confirmación; `null` si se teclean a mano. */
  idLectura: number | null;
  /** Cómo leyó el modelo cada campo, cuando se muestra una lectura. */
  lectura: Record<string, CampoLeido> | null;
  /** Los valores verificados antes, junto a una lectura nueva de un caso ya verificado (P3). */
  anterior: Record<string, ValorCampo> | null;
}

// Todos los campos, de una fuente de valores cuando la tiene, vacíos si no.
function completar(origen: Record<string, ValorCampo | undefined>): Record<string, ValorCampo> {
  return Object.fromEntries(CAMPOS.map((c) => [c.clave, origen[c.clave] ?? valorVacio(c)]));
}

/**
 * Los valores iniciales: la lectura nueva si el caso espera verificación; si no, la verificación
 * vigente; si no, la última lectura; si no, vacíos, para teclearlos a mano (un caso sin lectura, como
 * los de STG mientras la lectura está apagada).
 */
export function puntoDePartida(caso: LecturaCaso): PuntoDePartida {
  const { lectura, verificacion, progreso } = caso;
  const deLectura = lectura ? Object.fromEntries(Object.entries(lectura.campos).map(([clave, campo]) => [clave, campo.value])) : null;

  if (lectura && deLectura && (progreso === 'porVerificar' || progreso === 'verificadoNuevaLectura')) {
    return {
      valores: completar(deLectura),
      idLectura: lectura.id,
      lectura: lectura.campos,
      anterior: progreso === 'verificadoNuevaLectura' && verificacion ? verificacion.valores : null,
    };
  }

  if (verificacion) {
    return { valores: completar(verificacion.valores), idLectura: verificacion.idLectura, lectura: null, anterior: null };
  }

  if (lectura && deLectura) {
    return { valores: completar(deLectura), idLectura: lectura.id, lectura: lectura.campos, anterior: null };
  }

  return { valores: completar({}), idLectura: null, lectura: null, anterior: null };
}
